import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/Service/login.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { OTPVerificationComponent } from '../dialogs/Forget-Password-OTP-Verification/Change-Password-Otp-Verification.component';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {

  public currentYear: number = new Date().getFullYear();
  isButtonDisabled: boolean = false;
  timer: number = 30;
  timerInterval: any;

  public forgetPasswordForm: FormGroup = new FormGroup({
    username: new FormControl('', [Validators.required]),
    EmailId: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    retypePassword: new FormControl('', [Validators.required, Validators.minLength(8)])
  });

  constructor(public _dialogRef: MatDialogRef<ForgetPasswordComponent>, private encryptDecryptService: EncryptDecryptService, private _notificationService: NotificationService, private loginService: LoginService, private dialog: MatDialog) { }

  ngOnInit() {
    this.clearForm();
  }

  getFormValue(controlName: string): any {
    return this.forgetPasswordForm.get(controlName)?.value;
  }

  onClick_Submit(): any {
    let _input = {
      username: this.getFormValue("username"),
      EmailId: this.getFormValue("EmailId").toString(),
      password: this.getFormValue("password"),
      retypePassword: this.getFormValue("retypePassword")
    };

    if (_input.password.trim() != _input.retypePassword.trim()) {
      this._notificationService.showToast("Password and retype password should be same", "Warning");
      return;
    }

    if (!_input.password.trim().match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)) {
      this._notificationService.showToast("Wrong password combination", "Warning");
      return;
    }

    // if (_input.EmailId.) {
    //   this._notificationService.showToast("Mobile number is invalid", "Warning");
    //   return;
    // }
    let _otp = Math.floor((Math.random() * 100000) + 1)
    if (this.forgetPasswordForm.invalid) {
      return false;
    }

    else {
      let otp_input = {
        OTP: _otp,
        UserName: this.getFormValue("username"),
        MailId: this.getFormValue("EmailId").toString(),
        password: this.encryptDecryptService.encrypt(this.getFormValue("password").trim()),
        Flag: "INSERT"
      }
      this.loginService.PostForgetPasswordOTP(otp_input).subscribe(res => {
        if (res["successCode"] === 200) {
          // this._notificationService.showToast(res["successMessage"], "Success");
          // this.clearForm();
          // this._dialogRef.close();
          this.isButtonDisabled = true;
          this.timerInterval = setInterval(() => {
            this.timer--;
            if (this.timer <= 0) {
              // Enable the submit button when the timer reaches 0
              this.isButtonDisabled = false;
              this.timer = 30;
              clearInterval(this.timerInterval);
            }
          }, 1000);
          let input = {
            username: this.getFormValue("username").trim(),
            mobileNumber: this.getFormValue("EmailId").toString(),
            password: this.encryptDecryptService.encrypt(this.getFormValue("password").trim()),
            MailId: this.getFormValue("EmailId").toString()

          };
          let dialogRef = this.dialog.open(OTPVerificationComponent, {
            panelClass: 'mat-dialog-secondary',
            width: '40%',
            maxWidth: '60vw',
            data: input
          });
          dialogRef.afterClosed().subscribe((data: { successCode: number; }) => {
            if (data.successCode == 200)
              this._dialogRef.close();
          });
        }
        else {
          this._notificationService.showToast(res["successMessage"], "Warning");
        }
      });
      return;

    }



  }

  clearForm() {
    this.forgetPasswordForm.get('username')?.setValue('');
    this.forgetPasswordForm.get('mobileNumber')?.setValue('');
    this.forgetPasswordForm.get('username')?.setValue('');
    this.forgetPasswordForm.get('retypePassword')?.setValue('');
  }

  onClick_Cancel() {
    this._dialogRef.close();
  }

}
